import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import './LandingFooter.css';
import logoVertical from '../assets/logos/logo-ai-black-vertical.png';

const LandingFooter: React.FC = () => {
  const navigate = useNavigate();

  return (
    <footer className="landing-footer py-4 mt-5">
        <Container>
          <Row>
            <Col>
              <div className="d-flex gap-4" style={{ marginBottom: '40px' }}>
                <Button
                  variant="link"
                  className="text-dark p-0"
                  onClick={() => navigate('/about-us')}
                >
                  About Us
                </Button>
                <Button
                  variant="link"
                  className="text-dark p-0"
                  onClick={() => navigate('/terms')}
                >
                  Terms of Service
                </Button>
                <Button
                  variant="link"
                  className="text-dark p-0"
                  onClick={() => navigate('/terms')}
                >
                  Privacy Policy
                </Button>
              </div>
              <div className="d-flex align-items-end justify-content-between">
                <img src={logoVertical} alt="Revealer AI" className="logo-vertical" />
                <span className="small text-muted">© revealer ai 2026</span>
                <span className="small text-muted">All Rights Reserved</span>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
  );
};

export default LandingFooter;